/**
 * HUSKS smart search intent
 *
 * Shopify indexes product text and product filters separately. This bridge
 * recognizes a colour in a natural-language search and applies the existing
 * Shopify colour filter as well. For example, "gele trui" becomes a search
 * for "trui" with the native Geel filter applied.
 */
(() => {
  const COLOR_FILTER = 'filter.v.t.shopify.color-pattern';
  const COLORS = {
    beige: 'gid://shopify/TaxonomyValue/6',
    blauw: 'gid://shopify/TaxonomyValue/2',
    blue: 'gid://shopify/TaxonomyValue/2',
    bruin: 'gid://shopify/TaxonomyValue/7',
    brown: 'gid://shopify/TaxonomyValue/7',
    geel: 'gid://shopify/TaxonomyValue/14',
    gele: 'gid://shopify/TaxonomyValue/14',
    yellow: 'gid://shopify/TaxonomyValue/14',
    grijs: 'gid://shopify/TaxonomyValue/8',
    grijze: 'gid://shopify/TaxonomyValue/8',
    grey: 'gid://shopify/TaxonomyValue/8',
    gray: 'gid://shopify/TaxonomyValue/8',
    groen: 'gid://shopify/TaxonomyValue/9',
    groene: 'gid://shopify/TaxonomyValue/9',
    green: 'gid://shopify/TaxonomyValue/9',
    marineblauw: 'gid://shopify/TaxonomyValue/15',
    navy: 'gid://shopify/TaxonomyValue/15',
    oranje: 'gid://shopify/TaxonomyValue/10',
    orange: 'gid://shopify/TaxonomyValue/10',
    paars: 'gid://shopify/TaxonomyValue/12',
    paarse: 'gid://shopify/TaxonomyValue/12',
    purple: 'gid://shopify/TaxonomyValue/12',
    rood: 'gid://shopify/TaxonomyValue/13',
    rode: 'gid://shopify/TaxonomyValue/13',
    red: 'gid://shopify/TaxonomyValue/13',
    roze: 'gid://shopify/TaxonomyValue/11',
    roze: 'gid://shopify/TaxonomyValue/11',
    pink: 'gid://shopify/TaxonomyValue/11',
    wit: 'gid://shopify/TaxonomyValue/3',
    witte: 'gid://shopify/TaxonomyValue/3',
    white: 'gid://shopify/TaxonomyValue/3',
    zwart: 'gid://shopify/TaxonomyValue/1',
    zwarte: 'gid://shopify/TaxonomyValue/1',
    black: 'gid://shopify/TaxonomyValue/1',
    veelkleurig: 'gid://shopify/TaxonomyValue/2865',
    multicolor: 'gid://shopify/TaxonomyValue/2865',
  };

  function normalize(value) {
    return (value || '')
      .toLocaleLowerCase('nl-NL')
      .replace(/[^\p{L}\p{N}\s-]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getIntent(searchTerm) {
    const words = normalize(searchTerm).split(' ').filter(Boolean);
    const colors = [];
    const remainingWords = [];

    words.forEach((word) => {
      const color = COLORS[word];
      if (color && !colors.includes(color)) {
        colors.push(color);
      } else {
        remainingWords.push(word);
      }
    });

    return {
      query: remainingWords.join(' '),
      colors,
      hasColorIntent: colors.length > 0,
    };
  }

  function applyIntentToParams(params, searchTerm) {
    const intent = getIntent(searchTerm);

    // Keep a one-word colour search intact; Shopify needs a textual query to
    // build a results set before applying the native filter.
    if (!intent.hasColorIntent || !intent.query) return intent;

    params.set('q', intent.query);
    if (!params.has('type')) params.set('type', 'product');
    if (!params.has(COLOR_FILTER)) {
      intent.colors.forEach((color) => params.append(COLOR_FILTER, color));
    }
    return intent;
  }

  function addHiddenField(form, name, value) {
    const field = document.createElement('input');
    field.type = 'hidden';
    field.name = name;
    field.value = value;
    field.dataset.husksSearchIntent = 'true';
    form.append(field);
  }

  function enhanceForm(form) {
    const input = form.querySelector('input[name="q"]');
    if (!(input instanceof HTMLInputElement)) return;

    const intent = getIntent(input.value);
    if (!intent.hasColorIntent || !intent.query) return;

    input.value = intent.query;
    form.querySelectorAll('[data-husks-search-intent="true"]').forEach((field) => field.remove());

    if (!form.querySelector('input[name="type"]')) addHiddenField(form, 'type', 'product');
    if (!form.querySelector(`input[name="${COLOR_FILTER}"]`)) {
      intent.colors.forEach((color) => addHiddenField(form, COLOR_FILTER, color));
    }
  }

  window.HUSKSSearchIntent = { applyIntentToParams, getIntent };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.action.includes('/search')) enhanceForm(form);
    },
    true
  );

  // Also normalize direct links, bookmarks and searches submitted from the
  // standard search page, so every entry point uses the same result logic.
  if (window.location.pathname === '/search') {
    const url = new URL(window.location.href);
    const originalQuery = url.searchParams.get('q') || '';
    const intent = applyIntentToParams(url.searchParams, originalQuery);
    if (intent.hasColorIntent && intent.query && url.href !== window.location.href) {
      window.location.replace(url.toString());
    }
  }
})();
